import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxEoWebComponentsModule } from 'ngx-eo-web-components';
import { ImageButtonComponent } from './components/image-button/image-button.component';
import { LoadingComponent } from './components/loading/loading.component';
import { ModalComponent } from './components/modal/modal.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { RoleDropdownComponent } from './components/role-dropdown/role-dropdown.component';
import { TableComponent } from './components/table/table.component';
import { PrimengModule } from './primeng.module';
import { MetricComponent } from './components/metric/metric.component';
import { HasRoleDirective } from './directives/app-has-role.directive';
import { AuthHeaderComponent } from '../core/components/auth-header/auth-header.component';
import { AuthFooterComponent } from '../core/components/auth-footer/auth-footer.component';
import { ConfirmSubmitDialogComponent } from './components/submit-dialog/submit-dialog.component';
import { ViewPanelComponent } from './components/view-panel/view-panel.component';
import { UserFormDialogComponent } from '../user/components/user-form-dialog/user-form-dialog.component';
import { ViewModalComponent } from './components/view-modal/view-modal.component';
import { UserChangePasswordFormDialogComponent } from '../user/components/user-change-password-form-dialog/user-change-password-form-dialog.component';
import { ForgotPasswordDialogComponent } from '../core/components/forgot-password/forgot-password-dialog.component';

@NgModule({
  declarations: [
    ImageButtonComponent,
    LoadingComponent,
    TableComponent,
    ModalComponent,
    PageHeaderComponent,
    RoleDropdownComponent,
    MetricComponent,
    HasRoleDirective,
    ConfirmSubmitDialogComponent,
    AuthHeaderComponent,
    AuthFooterComponent,
    ViewPanelComponent,
    UserFormDialogComponent,
    ViewModalComponent,
    UserChangePasswordFormDialogComponent,
    ForgotPasswordDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxEoWebComponentsModule,
    PrimengModule,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    PrimengModule,
    NgxEoWebComponentsModule,
    ImageButtonComponent,
    LoadingComponent,
    TableComponent,
    ModalComponent,
    PageHeaderComponent,
    RoleDropdownComponent,
    MetricComponent,
    HasRoleDirective,
    ConfirmSubmitDialogComponent,
    AuthHeaderComponent,
    AuthFooterComponent,
    ViewPanelComponent,
    UserFormDialogComponent,
    ViewModalComponent,
    UserChangePasswordFormDialogComponent,
    ForgotPasswordDialogComponent
  ],
})
export class SharedModule { }
